import React from 'react';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

function BackButton({ link }) {
  const navigate = useNavigate();

  return link ? (
    <button className="back-button" onClick={() => link()}>
      <Icon>keyboard_arrow_left</Icon>Retour
    </button>
  ) : (
    <button className="back-button" onClick={() => navigate(-1)}>
      <Icon>keyboard_arrow_left</Icon>Retour
    </button>
  );
}

BackButton.propTypes = {
  link: PropTypes.func,
};

export default BackButton;
